/* SAGLOU i18n: strings come from snippets/saglou-js-i18n.liquid (window.SAGLOU_I18N, English only). */
window.sgT = window.sgT || function(s){ var d = window.SAGLOU_I18N; return (d && Object.prototype.hasOwnProperty.call(d, s)) ? d[s] : s; };
/*
 * SAGLOU · CART CONTROLLER V9
 *
 * Control único para:
 * - PDP
 * - rutinas / bundles
 * - Oferta de Otoño
 * - Ritual de Colágeno solo cuando lo añade explícitamente una PDP / pack
 * - Cart drawer Shrine PRO
 * - controles cantidad / eliminar
 * - upgrades Sérum / Loción
 *
 * V09:
 * - Los tratamientos gratuitos de ofertas quedan excluidos
 *   del motor de upgrades.
 * - Máscara LED, RF Facial y Sistema Facial:
 *   Sérum como producto independiente a 19 €.
 * - Resto de productos:
 *   mantienen upgrades mediante packs.
 * - Nuevo addItems():
 *   respeta exactamente los productos recibidos por la PDP / pack
 *   en una única petición /cart/add.js.
 * - Render inmediato de las sections devueltas por Shopify.
 */

(() => {

  if(
    window.SaglouCart?.version ===
    '9'
  ){
    return;
  }


  /* =========================================================
     CONFIG
  ========================================================= */

  const ROOT =
    window.Shopify?.routes?.root ||
    '/';


  const GIFT_HANDLE =
    'ritual-de-colageno-de-regalo';


  const SERUM_HANDLE =
    'collagen-serum';


  const SERUM_PROMO_HANDLE =
    'collagen-serum-complemento';


  const LOTION_HANDLE =
    'body-lotion';


  const PROMO_HANDLES = [
    'led-mask',
    'rf-facial',
    'pack-saglou-mascara-led-facial-rf-facial'
  ];


  const SECTIONS = [
    'cart-drawer',
    'cart-icon-bubble'
  ];


  const productCache =
    new Map();


  let operation =
    Promise.resolve();


  let syncing =
    false;


  let lastCart =
    null;


  /* =========================================================
     UPGRADE RULES
  ========================================================= */

  const UPGRADE_RULES = [

    {
      test:
        item =>
          item.handle ===
          'pack-saglou-depiladora-ipl-rf-corporal',

      target:
        'pack-saglou-depiladora-ipl-rf-corporal-locion-corporal',

      kind:
        'lotion',

      mode:
        'bundle',

      name:
        sgT('Loción Corporal Hidratante')
    },

    {
      test:
        item =>
          item.handle ===
          'pack-saglou-depiladora-ipl-masajeador-con-ventosa',

      target:
        'pack-saglou-depiladora-ipl-masajeador-con-ventosa-locion-corporal',

      kind:
        'lotion',

      mode:
        'bundle',

      name:
        sgT('Loción Corporal Hidratante')
    },

    {
      test:
        item =>
          item.handle ===
          'pack-saglou-rf-corporal-masajeador-con-ventosa',

      target:
        'pack-saglou-rf-corporal-masajeador-con-ventosa-locion-corporal',

      kind:
        'lotion',

      mode:
        'bundle',

      name:
        sgT('Loción Corporal Hidratante')
    },

    {
      test:
        item =>
          item.handle ===
          'ipl-hair-removal',

      target:
        'pack-saglou-depiladora-ipl-locion-corporal',

      kind:
        'lotion',

      mode:
        'bundle',

      name:
        sgT('Loción Corporal Hidratante')
    },

    {
      test:
        item =>
          item.handle ===
          'rf-body',

      target:
        'pack-saglou-rf-corporal-locion-corporal',

      kind:
        'lotion',

      mode:
        'bundle',

      name:
        sgT('Loción Corporal Hidratante')
    },

    {
      test:
        item =>
          item.handle ===
          'cupping-massager',

      target:
        'pack-saglou-masajeador-con-ventosa-locion-corporal',

      kind:
        'lotion',

      mode:
        'bundle',

      name:
        sgT('Loción Corporal Hidratante')
    }

  

  ];


  const COMPLEMENT_IMAGES = {

    serum:
      'https://cdn.shopify.com/s/files/1/0567/4755/6946/files/SAGLOU-pack-serum-colageno.png?v=1790458155',

    lotion:
      'https://cdn.shopify.com/s/files/1/0567/4755/6946/files/SAGLOU-pack-locion-hidratante-corporal.png?v=1790458156'

  };


  /* =========================================================
     MONEY
  ========================================================= */

  const money =
    cents => {

      try{

        var __cur = window.Shopify?.currency?.active || 'EUR';

        if(__cur === 'SEK' || __cur === 'DKK'){
          return Math.round(Number(cents || 0) / 100) + '\u00a0kr';
        }


        return new Intl.NumberFormat(
          'es-ES',
          {
            style:
              'currency',

            currency:
              window.Shopify?.currency?.active ||
              'EUR'
          }
        ).format(
          Number(
            cents || 0
          ) / 100
        );

      }catch(error){

        return `${(
          Number(
            cents || 0
          ) / 100
        )
          .toFixed(2)
          .replace('.',',')} €`;

      }

    };


  /* =========================================================
     STATE
  ========================================================= */

  function cacheCart(
    cart
  ){

    if(
      cart &&
      Array.isArray(
        cart.items
      )
    ){

      lastCart =
        cart;

    }

    return cart;

  }


  function currentCart(){

    return lastCart;

  }


  function purchaseItems(
    cart
  ){

    return (
      cart?.items ||
      []
    ).filter(
      item =>
        item.handle !==
        GIFT_HANDLE
    );

  }


  function giftItems(
    cart
  ){

    return (
      cart?.items ||
      []
    ).filter(
      item =>
        item.handle ===
        GIFT_HANDLE
    );

  }


  function getDrawer(){

    return document.querySelector(
      'cart-drawer'
    );

  }


  function getConfig(){

    return document.querySelector(
      '[data-sg-cart-config]'
    );

  }


  function getGiftVariantId(){

    return Number(
      getConfig()?.dataset
        .giftVariant ||
      0
    );

  }


  /* =========================================================
     ITEM HELPERS
  ========================================================= */

  function isIncludedTreatment(
    item
  ){

    if(!item){
      return false;
    }

    const type =
      String(
        item.properties?.[
          'Tipo'
        ] ||
        ''
      ).trim();

    return (
      type ===
      'Tratamiento incluido'
      ||
      item.properties?.[
        '_sg_offer_gift'
      ] ===
      'true'
    );

  }


  function isPromoActivator(
    item
  ){

    return !!(
      item &&
      PROMO_HANDLES.includes(
        item.handle
      )
    );

  }


  function isStandaloneComplement(
    item
  ){

    return (
      item?.handle ===
      SERUM_PROMO_HANDLE
      ||
      item?.properties?.[
        '_sg_complement'
      ] ===
      'true'
    );

  }


  /* =========================================================
     FETCH
  ========================================================= */

  async function jsonFetch(
    url,
    options={}
  ){

    const response =
      await fetch(
        url,
        {
          credentials:
            'same-origin',

          ...options,

          headers:{
            Accept:
              'application/json',

            ...(options.headers || {})
          }
        }
      );

    let data =
      null;

    try{

      data =
        await response.json();

    }catch(error){}

    if(!response.ok){

      throw new Error(
        data?.description ||
        data?.message ||
        sgT('No se ha podido actualizar el carrito.')
      );

    }

    return data;

  }


  async function getCart(){

    const cart =
      await jsonFetch(
        `${ROOT}cart.js?sg=${Date.now()}`
      );

    return cacheCart(
      cart
    );

  }


  /* =========================================================
     PRODUCT CACHE
  ========================================================= */

  async function getProduct(
    handle
  ){

    if(
      productCache.has(
        handle
      )
    ){

      return productCache.get(
        handle
      );

    }

    const promise =
      jsonFetch(
        `${ROOT}products/${encodeURIComponent(handle)}.js`
      );

    productCache.set(
      handle,
      promise
    );

    try{

      return await promise;

    }catch(error){

      productCache.delete(
        handle
      );

      throw error;

    }

  }


  async function getVariant(
    handle
  ){

    const product =
      await getProduct(
        handle
      );

    const variants =
      Array.isArray(
        product.variants
      )
        ?
        product.variants
        :
        [];

    const variant =
      variants.find(
        item =>
          item.available !== false
      )
      ||
      variants[0];

    if(!variant?.id){

      throw new Error(
        sgT('Este producto no está disponible actualmente.')
      );

    }

    return variant;

  }


  /* =========================================================
     SECTION DATA
  ========================================================= */

  function sectionsData(){

    return {

      sections:
        SECTIONS,

      sections_url:
        window.location.pathname

    };

  }


  /* =========================================================
     CART REQUESTS
  ========================================================= */

  async function addRaw(
    items
  ){

    return jsonFetch(
      `${ROOT}cart/add.js`,
      {
        method:
          'POST',

        headers:{
          'Content-Type':
            'application/json'
        },

        body:
          JSON.stringify({
            items
          })
      }
    );

  }


  async function addWithSections(
    items
  ){

    return jsonFetch(
      `${ROOT}cart/add.js`,
      {
        method:
          'POST',

        headers:{
          'Content-Type':
            'application/json'
        },

        body:
          JSON.stringify({

            items,

            ...sectionsData()

          })
      }
    );

  }


  async function changeWithSections(
    key,
    quantity
  ){

    return jsonFetch(
      `${ROOT}cart/change.js`,
      {
        method:
          'POST',

        headers:{
          'Content-Type':
            'application/json'
        },

        body:
          JSON.stringify({

            id:
              key,

            quantity:
              Math.max(
                0,
                Number(
                  quantity || 0
                )
              ),

            ...sectionsData()

          })
      }
    );

  }


  async function updateWithSections(
    updates={}
  ){

    return jsonFetch(
      `${ROOT}cart/update.js`,
      {
        method:
          'POST',

        headers:{
          'Content-Type':
            'application/json'
        },

        body:
          JSON.stringify({

            updates,

            ...sectionsData()

          })
      }
    );

  }


  async function refreshState(){

    return updateWithSections(
      {}
    );

  }


  /* =========================================================
     ENSURE CART OBJECT
  ========================================================= */

  function isFullCart(
    state
  ){

    return !!(
      state &&
      Array.isArray(
        state.items
      ) &&
      typeof state.total_price ===
        'number'
    );

  }


  async function fullCart(
    state
  ){

    if(
      isFullCart(
        state
      )
    ){

      return cacheCart(
        state
      );

    }

    return getCart();

  }


  /* =========================================================
     GIFT VARIANT
  ========================================================= */

  async function resolveGiftVariant(){

    const liquidId =
      getGiftVariantId();

    if(liquidId){

      return liquidId;

    }

    const variant =
      await getVariant(
        GIFT_HANDLE
      );

    return Number(
      variant.id
    );

  }


  function knownGiftPresent(){

    if(lastCart){

      return (
        giftItems(
          lastCart
        ).length > 0
      );

    }

    return (
      getConfig()?.dataset
        .giftPresent ===
      'true'
    );

  }


  function itemsContainGift(
    items
  ){

    const giftVariant =
      getGiftVariantId();

    if(!giftVariant){
      return false;
    }

    return (
      items ||
      []
    ).some(
      item =>
        Number(
          item.id
        ) ===
        Number(
          giftVariant
        )
    );

  }


  /* =========================================================
     GIFT NORMALIZATION
  ========================================================= */

  async function normalizeGift(
    suppliedCart
  ){

    let cart =
      await fullCart(
        suppliedCart
      );

    const purchases =
      purchaseItems(
        cart
      );

    const gifts =
      giftItems(
        cart
      );

    /*
     * V09.1
     *
     * El Ritual ya NO se añade automáticamente.
     *
     * Si una PDP / pack lo incluye, debe haber sido
     * añadido explícitamente desde esa propia compra.
     *
     * Aquí solo conservamos dos protecciones:
     * - si el carrito se queda únicamente con el Ritual,
     *   se elimina para no dejar un regalo huérfano;
     * - si por cualquier motivo existen varias líneas
     *   del Ritual, se conserva una sola con cantidad 1.
     */

    if(
      purchases.length === 0
    ){

      if(
        gifts.length === 0
      ){

        return cart;

      }

      const updates = {};

      gifts.forEach(
        gift => {

          updates[
            gift.key
          ] = 0;

        }
      );

      const state =
        await updateWithSections(
          updates
        );

      return fullCart(
        state
      );

    }

    if(
      gifts.length === 0
    ){

      return cart;

    }

    const updates = {};

    gifts.forEach(
      function(
        gift,
        index
      ){

        if(index === 0){

          if(
            Number(
              gift.quantity
            ) !== 1
          ){

            updates[
              gift.key
            ] = 1;

          }

        }else{

          updates[
            gift.key
          ] = 0;

        }

      }
    );

    if(
      Object.keys(
        updates
      ).length
    ){

      const state =
        await updateWithSections(
          updates
        );

      return fullCart(
        state
      );

    }

    return cart;

  }


  async function ensureGift(){

    const cart =
      lastCart ||
      await getCart();

    return normalizeGift(
      cart
    );

  }


  /* =========================================================
     HEADER COUNT
  ========================================================= */

  function updateHeaderCount(
    cart
  ){

    const amount =
      purchaseItems(
        cart
      )
        .reduce(
          (
            total,
            item
          ) =>
            total +
            Number(
              item.quantity ||
              0
            ),
          0
        );

    document
      .querySelectorAll(
        '.sg-header__cart, .sg-header__mobile-cart'
      )
      .forEach(
        function(
          link
        ){

          let badge =
            link.querySelector(
              '.sg-header__cart-count'
            );

          if(!amount){

            if(badge){

              badge.remove();

            }

            return;

          }

          if(!badge){

            badge =
              document.createElement(
                'span'
              );

            badge.className =
              'sg-header__cart-count';

            link.appendChild(
              badge
            );

          }

          badge.textContent =
            amount;

          badge.hidden =
            false;

        }
      );

  }


  /* =========================================================
     EMPTY DRAWER
  ========================================================= */

  function patchEmptyState(
    drawer
  ){

    if(!drawer){
      return;
    }

    const container =
      drawer.querySelector(
        '.drawer__inner-empty'
      );

    if(!container){
      return;
    }

    if(
      container.dataset
        .sgEmptyPatched ===
      'true'
    ){
      return;
    }

    container.dataset
      .sgEmptyPatched =
      'true';

    container.innerHTML = `

      <div class="sg-drawer-empty">

        <button
          type="button"
          class="sg-drawer-empty__close"
          data-sg-empty-close
          aria-label="${sgT('Cerrar carrito')}"
        >

          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 5L19 19M19 5L5 19"></path>
          </svg>

        </button>

        <p class="sg-drawer-empty__eyebrow">
          ${sgT('TU RUTINA')}
        </p>

        <h2>
          ${sgT('Tu selección está vacía.')}
        </h2>

        <p class="sg-drawer-empty__text">
          ${sgT('Explora los tratamientos Saglou o construye una rutina según tus prioridades.')}
        </p>

        <div class="sg-drawer-empty__actions">

          <a
            href="${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}collections/productos"
            class="sg-drawer-empty__link"
          >

            <span>
              ${sgT('Ver tratamientos')}
            </span>

            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4"></path>
            </svg>

          </a>

          <a
            href="${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}pages/personaliza-tu-rutina"
            class="sg-drawer-empty__link"
          >

            <span>
              ${sgT('Personalizar mi rutina')}
            </span>

            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4"></path>
            </svg>

          </a>

        </div>

      </div>

    `;

    const close =
      container.querySelector(
        '[data-sg-empty-close]'
      );

    close?.addEventListener(
      'click',
      function(){

        if(
          typeof drawer.close ===
          'function'
        ){

          drawer.close();

        }

      }
    );

  }


  /* =========================================================
     EMPTY STATE
  ========================================================= */

  function syncDrawerState(
    drawer,
    cart
  ){

    if(
      !drawer ||
      !cart
    ){
      return;
    }

    const empty =
      purchaseItems(
        cart
      ).length === 0;

    drawer.classList.toggle(
      'is-empty',
      empty
    );

    drawer
      .querySelectorAll(
        'cart-drawer-items'
      )
      .forEach(
        function(
          items
        ){

          items.classList.toggle(
            'is-empty',
            empty
          );

        }
      );

  }


  /* =========================================================
     CLEAN TITLES
  ========================================================= */

  function cleanDrawerTitles(
    drawer
  ){

    if(!drawer){
      return;
    }

    drawer
      .querySelectorAll(
        '.cart-item__name'
      )
      .forEach(
        function(
          element
        ){

          const original =
            element.textContent
              .replace(
                /\s+/g,
                ' '
              )
              .trim();

          const clean =
            original.replace(
              /^Pack\s+Saglou\s*[—–-]\s*/i,
              ''
            );

          if(
            clean &&
            clean !== original
          ){

            element.textContent =
              clean;

          }

        }
      );

  }


  /* =========================================================
     CROSS SELL
  ========================================================= */

  function cartHasComplement(
    cart,
    kind
  ){

    return (
      cart?.items ||
      []
    ).some(
      function(
        item
      ){

        const title =
          item.product_title ||
          item.title ||
          '';

        const source =
          `${item.handle || ''} ${title}`;

        if(
          kind ===
          'serum'
        ){

          return (
            item.handle ===
              SERUM_HANDLE
            ||
            item.handle ===
              SERUM_PROMO_HANDLE
            ||
            /serum|sérum/i.test(
              source
            )
          );

        }

        return (
          item.handle ===
            LOTION_HANDLE
          ||
          /locion|loción/i.test(
            source
          )
        );

      }
    );

  }


  function getAcceptedUpgrade(
    cart
  ){

    return (
      cart?.items ||
      []
    ).find(
      item =>
        item.properties?.[
          '_sg_upgrade_from'
        ]
        &&
        item.properties?.[
          '_sg_upgrade_kind'
        ]
    );

  }


  function findRule(
    item
  ){

    return UPGRADE_RULES.find(
      candidate =>
        candidate.test(
          item
        )
    );

  }


  function getRecommendation(
    cart
  ){

    const items =
      purchaseItems(
        cart
      );

    /*
     * PRIORIDAD ABSOLUTA:
     * Si hay una Máscara, RF Facial o Sistema Facial
     * de campaña, el cross-sell pertenece a ese sistema.
     *
     * Los productos gratis añadidos junto al sistema
     * NO pueden apropiarse del bloque de cross-sell.
     */

    const promoItem =
      items.find(
        item =>
          isPromoActivator(
            item
          )
          &&
          !isIncludedTreatment(
            item
          )
      );

    if(promoItem){

      const promoRule =
        findRule(
          promoItem
        );

      if(
        promoRule
        &&
        promoRule.mode ===
          'standalone'
        &&
        !cartHasComplement(
          cart,
          promoRule.kind
        )
      ){

        return {
          item:
            promoItem,

          rule:
            promoRule
        };

      }

    }

    /*
     * RESTO DE PRODUCTOS:
     * Conservan motor antiguo de packs.
     *
     * Excluimos:
     * - tratamientos incluidos gratis;
     * - complementos independientes;
     * - productos que ya sean upgrades.
     */

    for(
      const item of
      items
    ){

      if(
        isIncludedTreatment(
          item
        )
      ){
        continue;
      }

      if(
        isStandaloneComplement(
          item
        )
      ){
        continue;
      }

      if(
        item.properties?.[
          '_sg_upgrade_from'
        ]
      ){
        continue;
      }

      const rule =
        findRule(
          item
        );

      if(
        !rule ||
        cartHasComplement(
          cart,
          rule.kind
        )
      ){
        continue;
      }

      return {
        item,
        rule
      };

    }

    return null;

  }


  function upgradeMarkup(
    cart
  ){

    /* Las ofertas de upgrade tienen precios fijos en euros: solo en mercados EUR */
    if((window.Shopify?.currency?.active || 'EUR') !== 'EUR'){
      return '';
    }

    const accepted =
      getAcceptedUpgrade(
        cart
      );

    /*
     * PACK ANTIGUO YA ACEPTADO
     */

    if(accepted){

      const kind =
        accepted.properties[
          '_sg_upgrade_kind'
        ];

      const label =
        kind ===
        'serum'
          ?
          sgT('Sérum Facial con Colágeno')
          :
          sgT('Loción Corporal Hidratante');

      const short =
        kind ===
        'serum'
          ? sgT('Sérum') : sgT('Loción');

      return `

        <div class="sg-cart-crosssell__media">

          <img
            src="${COMPLEMENT_IMAGES[kind]}"
            alt="${label}"
            loading="lazy"
          >

        </div>

        <div class="sg-cart-crosssell__copy">

          <span class="sg-cart-crosssell__eyebrow">
            ${sgT('AÑADIDO A TU RUTINA')}
          </span>

          <strong>
            ${label}
          </strong>

          <p>
            ${sgT('El complemento está incluido dentro del pack seleccionado.')}
          </p>

          <div class="sg-cart-crosssell__price">
            <span>+14,44 €</span>
          </div>

          <button
            type="button"
            data-sg-cart-downgrade
            data-key="${accepted.key}"
            data-base="${accepted.properties['_sg_upgrade_from']}"
          >

            <span>
              ${sgT('Quitar')} ${short}
            </span>

            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path d="M3.5 12.5 12.5 3.5M5.5 3.5h7v7"/>
            </svg>

          </button>

        </div>

      `;

    }

    const recommendation =
      getRecommendation(
        cart
      );

    if(!recommendation){
      return '';
    }

    const {
      item,
      rule
    } =
      recommendation;

    const standalone =
      rule.mode ===
      'standalone';

    const cta =
      standalone
        ?
        `${sgT('Añadir Sérum')} · ${rule.priceLabel || '19,00 €'}`
        :
        rule.kind ===
        'serum'
          ?
          sgT('Añadir Sérum por 14,44 €')
          :
          sgT('Añadir Loción por 14,44 €');

    const copy =
      standalone
        ?
        sgT('Completa tu rutina con el Sérum Facial con Colágeno.')
        :
        rule.kind ===
        'serum'
          ?
          sgT('Completa tu cuidado facial con el precio especial de la rutina.')
          :
          sgT('Completa tu cuidado corporal con hidratación y el precio especial de la rutina.');

    const oldPrice =
      standalone
        ?
        ''
        :
        `
          <s>
            19,00 €
          </s>
        `;

    const finalPrice =
      standalone
        ?
        rule.priceLabel ||
        '19,00 €'
        :
        '14,44 €';

    return `

      <div class="sg-cart-crosssell__media">

        <img
          src="${COMPLEMENT_IMAGES[rule.kind]}"
          alt="${rule.name}"
          loading="lazy"
        >

      </div>

      <div class="sg-cart-crosssell__copy">

        <span class="sg-cart-crosssell__eyebrow">
          ${sgT('COMPLETA TU RUTINA')}
        </span>

        <strong>
          ${rule.name}
        </strong>

        <p>
          ${copy}
        </p>

        <div class="sg-cart-crosssell__price">

          ${oldPrice}

          <span>
            ${finalPrice}
          </span>

        </div>

        <button
          type="button"
          data-sg-cart-upgrade
          data-key="${item.key}"
          data-target="${rule.target}"
          data-kind="${rule.kind}"
          data-mode="${rule.mode || 'bundle'}"
        >

          <span>
            ${cta}
          </span>

          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M3.5 12.5 12.5 3.5M5.5 3.5h7v7"/>
          </svg>

        </button>

      </div>

    `;

  }


  function renderUpgradeBlocks(
    cart
  ){

    if(
      !cart ||
      !Array.isArray(
        cart.items
      )
    ){
      return;
    }

    document
      .querySelectorAll(
        '[data-sg-cart-crosssell]'
      )
      .forEach(
        function(
          block
        ){

          const html =
            upgradeMarkup(
              cart
            );

          block.innerHTML =
            html;

          block.hidden =
            !html;

        }
      );

  }


  /* =========================================================
     LOADING
  ========================================================= */

  function setDrawerLoading(
    value
  ){

    const drawer =
      getDrawer();

    if(!drawer){
      return;
    }

    const inner =
      drawer.querySelector(
        '.drawer__inner'
      );

    if(!inner){
      return;
    }

    let busy =
      inner.querySelector(
        '.sg-cart-busy'
      );

    if(
      value &&
      !busy
    ){

      busy =
        document.createElement(
          'div'
        );

      busy.className =
        'sg-cart-busy';

      busy.textContent =
        sgT('ACTUALIZANDO TU RUTINA');

      inner.appendChild(
        busy
      );

    }

    if(busy){

      busy.hidden =
        !value;

    }

  }


  /* =========================================================
     OPEN
  ========================================================= */

  function openDrawerNow(trigger){

    const drawer =
      getDrawer();

    if(!drawer){
      return null;
    }

    patchEmptyState(
      drawer
    );

    if(
      typeof drawer.open ===
      'function'
    ){

      drawer.open(trigger);

    }else{

      drawer.classList.add(
        'animate',
        'active'
      );

    }

    return drawer;

  }


  function primeDrawer(){

    const drawer =
      openDrawerNow();

    if(drawer){

      setDrawerLoading(
        true
      );

    }

  }


  /* =========================================================
     POST RENDER
  ========================================================= */

  function postRender(
    cart
  ){

    const drawer =
      getDrawer();

    if(!drawer){
      return;
    }

    cacheCart(
      cart
    );

    patchEmptyState(
      drawer
    );

    syncDrawerState(
      drawer,
      cart
    );

    cleanDrawerTitles(
      drawer
    );

    updateHeaderCount(
      cart
    );

    renderUpgradeBlocks(
      cart
    );

    if(
      typeof window
        .SGApplyDrawerImages ===
      'function'
    ){

      window.SGApplyDrawerImages(
        cart
      );

    }

    setDrawerLoading(
      false
    );

  }


  /* =========================================================
     FAST SECTION RENDER
  ========================================================= */

  function renderSectionsFast(
    state,
    {
      open=true
    }={}
  ){

    const drawer =
      getDrawer();

    if(
      !drawer
      ||
      !state?.sections?.[
        'cart-drawer'
      ]
      ||
      typeof drawer.renderContents !==
        'function'
    ){

      return false;

    }

    drawer.renderContents(
      state,
      !open
    );

    requestAnimationFrame(
      function(){

        const freshDrawer =
          getDrawer();

        patchEmptyState(
          freshDrawer
        );

        cleanDrawerTitles(
          freshDrawer
        );

        /*
         * Quitamos el overlay en cuanto Shopify
         * ha devuelto el HTML actualizado.
         *
         * La sincronización cart.js posterior
         * ocurre sin bloquear visualmente.
         */

        setDrawerLoading(
          false
        );

      }
    );

    return true;

  }


  function backgroundSync(){

    getCart()
      .then(
        function(
          cart
        ){

          postRender(
            cart
          );

        }
      )
      .catch(
        function(
          error
        ){

          console.warn(
            'SAGLOU · Background cart sync:',
            error
          );

          setDrawerLoading(
            false
          );

        }
      );

  }


  /* =========================================================
     RENDER SHRINE
  ========================================================= */

  async function renderCart(
    state,
    {
      open=true
    }={}
  ){

    const cart =
      await fullCart(
        state
      );

    cacheCart(
      cart
    );

    const drawer =
      getDrawer();

    if(!drawer){

      setDrawerLoading(
        false
      );

      return cart;

    }

    syncDrawerState(
      drawer,
      cart
    );

    if(
      state?.sections?.[
        'cart-drawer'
      ]
      &&
      typeof drawer.renderContents ===
        'function'
    ){

      drawer.renderContents(
        state,
        !open
      );

      requestAnimationFrame(
        function(){

          postRender(
            cart
          );

        }
      );

    }else{

      const freshState =
        await refreshState();

      const freshCart =
        await fullCart(
          freshState
        );

      drawer.renderContents?.(
        freshState,
        !open
      );

      requestAnimationFrame(
        function(){

          postRender(
            freshCart
          );

        }
      );

    }

    return cart;

  }


  /* =========================================================
     MULTI ADD · V9
  ========================================================= */

  async function addItems(
    suppliedItems,
    {
      openDrawer=true,
      ensureGift=true
    }={}
  ){

    const items =
      Array.isArray(
        suppliedItems
      )
        ?
        suppliedItems
          .filter(
            item =>
              item &&
              Number(
                item.id
              )
          )
          .map(
            item => ({

              ...item,

              id:
                Number(
                  item.id
                ),

              quantity:
                Number(
                  item.quantity ||
                  1
                )

            })
          )
        :
        [];

    if(!items.length){

      throw new Error(
        sgT('No hay productos válidos para añadir.')
      );

    }

    /*
     * V09.1
     *
     * No añadimos el Ritual automáticamente.
     *
     * addItems() respeta exactamente los items recibidos.
     * Si una PDP / pack incluye el Ritual, debe enviarlo
     * explícitamente dentro de suppliedItems.
     *
     * El parámetro ensureGift se conserva únicamente
     * por compatibilidad con llamadas existentes.
     */

    primeDrawer();

    /*
     * UNA sola petición con los items recibidos.
     *
     * Si el Ritual forma parte de la oferta,
     * debe venir explícitamente en esa lista.
     *
     * Shopify devuelve también las sections
     * ya renderizadas.
     */

    const state =
      await addWithSections(
        items
      );

    /*
     * Pintamos el carrito inmediatamente,
     * sin esperar a cart.js.
     */

    renderSectionsFast(
      state,
      {
        open:
          openDrawer
      }
    );

    /*
     * Sincronización posterior no bloqueante.
     */

    backgroundSync();

    return state;

  }


  /* =========================================================
     ADD PRODUCT NORMAL
  ========================================================= */

  async function addVariant(
    id,
    {
      quantity=1,
      properties,
      openDrawer=true
    }={}
  ){

    return addItems(
      [
        {
          id:
            Number(
              id
            ),

          quantity:
            Number(
              quantity ||
              1
            ),

          ...(properties
            ?
            {
              properties
            }
            :
            {})
        }
      ],
      {
        openDrawer,
        ensureGift:true
      }
    );

  }


  async function addHandle(
    handle,
    options={}
  ){

    const variant =
      await getVariant(
        handle
      );

    return addVariant(
      variant.id,
      options
    );

  }


  /* =========================================================
     EXTERNAL ADD · LEGACY
  ========================================================= */

  async function afterExternalAdd(
    {
      openDrawer=true
    }={}
  ){

    /*
     * Se mantiene para componentes antiguos.
     *
     * V09.1:
     * este recorrido ya no añade el Ritual por su cuenta.
     * Solo resincroniza y renderiza el carrito.
     */

    primeDrawer();

    const state =
      await refreshState();

    renderSectionsFast(
      state,
      {
        open:
          openDrawer
      }
    );

    backgroundSync();

    return state;

  }


  /* =========================================================
     LINE LOOKUP
  ========================================================= */

  function getDrawerLineIndex(
    target
  ){

    const line =
      target.closest(
        '.cart-drawer-item[data-index]'
      );

    if(!line){

      return -1;

    }

    return (
      Number(
        line.dataset.index
      ) - 1
    );

  }


  async function resolveLineItem(
    target
  ){

    let cart =
      lastCart;

    if(
      !cart
      ||
      !Array.isArray(
        cart.items
      )
    ){

      cart =
        await getCart();

    }

    const index =
      getDrawerLineIndex(
        target
      );

    if(index < 0){

      return null;

    }

    return (
      cart.items[
        index
      ]
      ||
      null
    );

  }


  /* =========================================================
     CHANGE DRAWER LINE
  ========================================================= */

  async function changeDrawerLine(
    target,
    quantity
  ){

    const item =
      await resolveLineItem(
        target
      );

    if(!item?.key){

      throw new Error(
        sgT('No se ha podido identificar el producto del carrito.')
      );

    }

    let state =
      await changeWithSections(
        item.key,
        quantity
      );

    let cart =
      await fullCart(
        state
      );

    const purchases =
      purchaseItems(
        cart
      );

    const gifts =
      giftItems(
        cart
      );

    /*
     * Si el usuario elimina todos los productos de compra
     * y queda únicamente el Ritual, retiramos ese regalo
     * huérfano.
     *
     * IMPORTANTE:
     * ya NO añadimos el Ritual cuando no existe.
     */

    if(
      purchases.length === 0
      &&
      gifts.length
    ){

      const updates = {};

      gifts.forEach(
        gift => {

          updates[
            gift.key
          ] = 0;

        }
      );

      state =
        await updateWithSections(
          updates
        );

      cart =
        await fullCart(
          state
        );

    }

    cacheCart(
      cart
    );

    return renderCart(
      state,
      {
        open:true
      }
    );

  }


  /* =========================================================
     BUNDLE UPGRADE
  ========================================================= */

  async function swapToBundle(
    sourceKey,
    targetHandle,
    kind,
    {
      openDrawer=true,
      reloadPage=false
    }={}
  ){

    primeDrawer();

    let cart =
      lastCart ||
      await getCart();

    let source =
      (
        cart.items ||
        []
      ).find(
        item =>
          item.key ===
          sourceKey
      );

    if(!source){

      cart =
        await getCart();

      source =
        (
          cart.items ||
          []
        ).find(
          item =>
            item.key ===
            sourceKey
        );

    }

    if(!source){

      setDrawerLoading(
        false
      );

      return;

    }

    /*
     * Seguridad:
     * un tratamiento incluido gratuitamente
     * NUNCA puede convertirse en un pack.
     */

    if(
      isIncludedTreatment(
        source
      )
    ){

      setDrawerLoading(
        false
      );

      return;

    }

    /*
     * Seguridad:
     * los activadores de Oferta de Otoño
     * tampoco pueden pasar por swapToBundle.
     */

    if(
      isPromoActivator(
        source
      )
    ){

      setDrawerLoading(
        false
      );

      return;

    }

    const targetVariant =
      await getVariant(
        targetHandle
      );

    await addRaw([
      {

        id:
          Number(
            targetVariant.id
          ),

        quantity:
          Number(
            source.quantity ||
            1
          ),

        properties:{

          '_sg_upgrade_from':
            source.handle,

          '_sg_upgrade_kind':
            kind

        }

      }
    ]);

    const state =
      await changeWithSections(
        source.key,
        0
      );

    const finalCart =
      await fullCart(
        state
      );

    cacheCart(
      finalCart
    );

    if(reloadPage){

      window.location.reload();

      return;

    }

    return renderCart(
      state,
      {
        open:
          openDrawer
      }
    );

  }


  /* =========================================================
     STANDALONE COMPLEMENT
  ========================================================= */

  async function addStandaloneComplement(
    targetHandle,
    {
      openDrawer=true,
      reloadPage=false
    }={}
  ){

    const variant =
      await getVariant(
        targetHandle
      );

    const state =
      await addItems(
        [
          {
            id:
              Number(
                variant.id
              ),

            quantity:
              1,

            properties:{
              '_sg_complement':
                'true'
            }
          }
        ],
        {
          openDrawer,
          ensureGift:true
        }
      );

    if(reloadPage){

      window.location.reload();

    }

    return state;

  }


  /* =========================================================
     DOWNGRADE
  ========================================================= */

  async function downgradeBundle(
    bundleKey,
    baseHandle,
    {
      openDrawer=true,
      reloadPage=false
    }={}
  ){

    primeDrawer();

    let cart =
      lastCart ||
      await getCart();

    let source =
      (
        cart.items ||
        []
      ).find(
        item =>
          item.key ===
          bundleKey
      );

    if(!source){

      cart =
        await getCart();

      source =
        (
          cart.items ||
          []
        ).find(
          item =>
            item.key ===
            bundleKey
        );

    }

    if(
      !source ||
      !baseHandle
    ){

      setDrawerLoading(
        false
      );

      return;

    }

    const baseVariant =
      await getVariant(
        baseHandle
      );

    await addRaw([
      {

        id:
          Number(
            baseVariant.id
          ),

        quantity:
          Number(
            source.quantity ||
            1
          )

      }
    ]);

    const state =
      await changeWithSections(
        source.key,
        0
      );

    const finalCart =
      await fullCart(
        state
      );

    cacheCart(
      finalCart
    );

    if(reloadPage){

      window.location.reload();

      return;

    }

    return renderCart(
      state,
      {
        open:
          openDrawer
      }
    );

  }


  /* =========================================================
     QUEUE
  ========================================================= */

  function enqueue(
    task
  ){

    operation =
      operation
        .then(
          async function(){

            syncing =
              true;

            try{

              return await task();

            }finally{

              syncing =
                false;

            }

          }
        )
        .catch(
          function(
            error
          ){

            syncing =
              false;

            setDrawerLoading(
              false
            );

            console.error(
              'SAGLOU CART:',
              error
            );

            throw error;

          }
        );

    return operation;

  }


  /* =========================================================
     PDP · FEEDBACK INMEDIATO
  ========================================================= */

  document.addEventListener(
    'click',
    function(
      event
    ){

      const trigger =
        event.target.closest?.(
          '[data-sg-product-cta], [data-sg-final-add], .sg-final-cta__button'
        );

      if(
        !trigger ||
        trigger.disabled
      ){
        return;
      }

      const scope =
        trigger.closest(
          '.sg-pdp-hero, .sg-routine-final-v2, .sg-final-cta'
        );

      if(!scope){
        return;
      }

      primeDrawer();

    },
    true
  );


  /* =========================================================
     PDP NORMAL
  ========================================================= */

  document.addEventListener(
    'submit',
    function(
      event
    ){

      const form =
        event.target.closest?.(
          '.sg-pdp-hero form.sg-product-form, .sg-final-cta form.sg-final-cta__form'
        );

      if(
        !form ||
        event.defaultPrevented
      ){
        return;
      }

      event.preventDefault();

      const button =
        event.submitter ||
        form.querySelector(
          '[type="submit"]'
        );

      if(
        !button
        ||
        button.disabled
        ||
        form.dataset.sgAdding ===
          'true'
      ){
        return;
      }

      const variantId =
        form.querySelector(
          '[name="id"]'
        )?.value;

      if(!variantId){
        return;
      }

      primeDrawer();

      form.dataset.sgAdding =
        'true';

      const original =
        button.innerHTML;

      button.disabled =
        true;

      button.setAttribute(
        'aria-busy',
        'true'
      );

      enqueue(
        () =>
          addVariant(
            variantId,
            {
              openDrawer:true
            }
          )
      )
        .catch(
          function(
            error
          ){

            let message =
              form.querySelector(
                '.sg-cart-error'
              );

            if(!message){

              message =
                document.createElement(
                  'p'
                );

              message.className =
                'sg-cart-error';

              form.appendChild(
                message
              );

            }

            message.textContent =
              error.message ||
              sgT('No se pudo añadir el producto.');

          }
        )
        .finally(
          function(){

            button.disabled =
              false;

            button.removeAttribute(
              'aria-busy'
            );

            button.innerHTML =
              original;

            delete form.dataset.sgAdding;

          }
        );

    }
  );


  /* =========================================================
     HEADER CART
  ========================================================= */

  document.addEventListener(
    'click',
    function(
      event
    ){

      const link =
        event.target.closest?.(
          '.sg-header__cart, .sg-header__mobile-cart'
        );

      if(
        !link
        ||
        event.metaKey
        ||
        event.ctrlKey
        ||
        event.shiftKey
        ||
        event.altKey
      ){
        return;
      }

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

      const drawer =
        openDrawerNow(link);

      if(
        drawer &&
        lastCart
      ){

        postRender(
          lastCart
        );

      }

    },
    true
  );


  /* =========================================================
     DRAWER REMOVE
  ========================================================= */

  document.addEventListener(
    'click',
    function(
      event
    ){

      const remove =
        event.target.closest?.(
          'cart-drawer cart-remove-button button'
        );

      if(!remove){
        return;
      }

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

      if(syncing){
        return;
      }

      primeDrawer();

      enqueue(
        () =>
          changeDrawerLine(
            remove,
            0
          )
      );

    },
    true
  );


  /* =========================================================
     DRAWER + / -
  ========================================================= */

  document.addEventListener(
    'click',
    function(
      event
    ){

      const button =
        event.target.closest?.(
          'cart-drawer .quantity__button'
        );

      if(!button){
        return;
      }

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

      if(syncing){
        return;
      }

      const line =
        button.closest(
          '.cart-drawer-item'
        );

      const input =
        line?.querySelector(
          '.quantity__input'
        );

      if(!input){
        return;
      }

      const current =
        Number(
          input.value ||
          0
        );

      const min =
        Number(
          input.min ||
          0
        );

      const max =
        input.max
          ?
          Number(
            input.max
          )
          :
          Infinity;

      const step =
        Number(
          input.step ||
          1
        );

      const plus =
        button.classList.contains(
          'quantity__button--plus'
        );

      let next =
        plus
          ?
          current + step
          :
          current - step;

      next =
        Math.max(
          0,
          min || 0,
          next
        );

      next =
        Math.min(
          max,
          next
        );

      if(
        next === current
      ){
        return;
      }

      primeDrawer();

      enqueue(
        () =>
          changeDrawerLine(
            button,
            next
          )
      );

    },
    true
  );


  /* =========================================================
     MANUAL QUANTITY INPUT
  ========================================================= */

  document.addEventListener(
    'change',
    function(
      event
    ){

      const input =
        event.target.closest?.(
          'cart-drawer .quantity__input'
        );

      if(!input){
        return;
      }

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

      if(syncing){
        return;
      }

      let quantity =
        Number(
          input.value ||
          0
        );

      const min =
        Number(
          input.min ||
          0
        );

      const max =
        input.max
          ?
          Number(
            input.max
          )
          :
          Infinity;

      quantity =
        Math.max(
          min,
          quantity
        );

      quantity =
        Math.min(
          max,
          quantity
        );

      primeDrawer();

      enqueue(
        () =>
          changeDrawerLine(
            input,
            quantity
          )
      );

    },
    true
  );


  /* =========================================================
     UPGRADES
  ========================================================= */

  document.addEventListener(
    'click',
    function(
      event
    ){

      const upgrade =
        event.target.closest?.(
          '[data-sg-cart-upgrade]'
        );

      if(upgrade){

        event.preventDefault();

        const reloadPage =
          !!upgrade.closest(
            '[data-sg-cart-page]'
          );

        const mode =
          upgrade.dataset.mode ||
          'bundle';

        if(
          mode ===
          'standalone'
        ){

          enqueue(
            () =>
              addStandaloneComplement(
                upgrade.dataset.target,
                {
                  openDrawer:
                    !reloadPage,

                  reloadPage
                }
              )
          );

          return;

        }

        enqueue(
          () =>
            swapToBundle(
              upgrade.dataset.key,
              upgrade.dataset.target,
              upgrade.dataset.kind,
              {
                openDrawer:
                  !reloadPage,

                reloadPage
              }
            )
        );

        return;

      }

      const downgrade =
        event.target.closest?.(
          '[data-sg-cart-downgrade]'
        );

      if(downgrade){

        event.preventDefault();

        const reloadPage =
          !!downgrade.closest(
            '[data-sg-cart-page]'
          );

        enqueue(
          () =>
            downgradeBundle(
              downgrade.dataset.key,
              downgrade.dataset.base,
              {
                openDrawer:
                  !reloadPage,

                reloadPage
              }
            )
        );

      }

    }
  );


  /* =========================================================
     FULL CART PAGE
  ========================================================= */

  document.addEventListener(
    'click',
    function(
      event
    ){

      const action =
        event.target.closest?.(
          '[data-sg-cart-page-action]'
        );

      if(!action){
        return;
      }

      event.preventDefault();

      const key =
        action.dataset.key;

      const current =
        Number(
          action.dataset.current ||
          0
        );

      const type =
        action.dataset
          .sgCartPageAction;

      const quantity =
        type ===
        'plus'
          ?
          current + 1
          :
          type ===
          'minus'
            ?
            Math.max(
              0,
              current - 1
            )
            :
            0;

      enqueue(
        async function(){

          await changeWithSections(
            key,
            quantity
          );

          await ensureGift();

          window.location.reload();

        }
      );

    }
  );


  /* =========================================================
     EXISTING PACK ENGINES
  ========================================================= */

  document.addEventListener(
    'cart:refresh',
    function(){

      if(syncing){
        return;
      }

      setTimeout(
        function(){

          enqueue(
            async function(){

              const state =
                await refreshState();

              return renderCart(
                state,
                {
                  open:false
                }
              );

            }
          );

        },
        20
      );

    }
  );


  document.addEventListener(
    'cart:updated',
    function(){

      if(syncing){
        return;
      }

      setTimeout(
        function(){

          enqueue(
            async function(){

              primeDrawer();

              const cart =
                await getCart();

              await normalizeGift(
                cart
              );

              const state =
                await refreshState();

              return renderCart(
                state,
                {
                  open:true
                }
              );

            }
          );

        },
        20
      );

    }
  );


  /* =========================================================
     PUBLIC API
  ========================================================= */

  const api = {

    version:
      '9',

    getCart,

    currentCart,

    ensureGift,

    renderUpgradeBlocks,

    money,

    addItems:
      (
        items,
        options
      ) => {

        return enqueue(
          () =>
            addItems(
              items,
              options
            )
        );

      },

    refresh:
      () =>
        enqueue(
          async function(){

            const state =
              await refreshState();

            return renderCart(
              state,
              {
                open:false
              }
            );

          }
        ),

    openDrawer:
      () => {

        openDrawerNow();

        return Promise.resolve(
          lastCart
        );

      },

    addVariant:
      (
        id,
        options
      ) => {

        return enqueue(
          () =>
            addVariant(
              id,
              options
            )
        );

      },

    addHandle:
      (
        handle,
        options
      ) => {

        return enqueue(
          () =>
            addHandle(
              handle,
              options
            )
        );

      },

    afterExternalAdd:
      options => {

        return enqueue(
          () =>
            afterExternalAdd(
              options
            )
        );

      }

  };


  window.SaglouCart =
    api;


  window.SGCart =
    api;


  /* =========================================================
     INITIAL
  ========================================================= */

  async function initialSync(){

    const drawer =
      getDrawer();

    patchEmptyState(
      drawer
    );

    try{

      let cart =
        await getCart();

      const purchases =
        purchaseItems(
          cart
        );

      const gifts =
        giftItems(
          cart
        );

      const badGiftState =
        (
          purchases.length === 0
          &&
          gifts.length > 0
        )
        ||
        (
          purchases.length > 0
          &&
          (
            gifts.length !== 1
            ||
            Number(
              gifts[0]?.quantity ||
              0
            ) !== 1
          )
        );

      if(badGiftState){

        cart =
          await normalizeGift(
            cart
          );

      }

      cacheCart(
        cart
      );

      syncDrawerState(
        drawer,
        cart
      );

      updateHeaderCount(
        cart
      );

      cleanDrawerTitles(
        drawer
      );

      renderUpgradeBlocks(
        cart
      );

      if(
        typeof window
          .SGApplyDrawerImages ===
        'function'
      ){

        window.SGApplyDrawerImages(
          cart
        );

      }

    }catch(error){

      console.warn(
        'SAGLOU · Initial cart sync:',
        error
      );

    }

  }


  if(
    document.readyState ===
    'loading'
  ){

    document.addEventListener(
      'DOMContentLoaded',
      function(){

        setTimeout(
          initialSync,
          100
        );

      },
      {
        once:true
      }
    );

  }else{

    setTimeout(
      initialSync,
      100
    );

  }


  document.addEventListener(
    'shopify:section:load',
    function(){

      patchEmptyState(
        getDrawer()
      );

    }
  );

})();